import { buildExploreMapLayer } from "@lib/logic";
import { getBuildingResources, type Resource, useAppSelector } from "@lib/store";
import { useRequiredContext } from "@lib/utils";

import { HaNContext } from "../shell/HaNContext";
import { HaNMapStageContext, useHaNMapLayer } from "../shell/regions/HaNMapStageContext";

const NO_RESOURCES: Resource[] = [];
const NO_TYPE_FILTERS: string[] = [];

export const ExploreMap = () => {
  const { tab } = useRequiredContext(HaNContext);
  const { floorId } = useRequiredContext(HaNMapStageContext);

  if (tab !== "explore" || !floorId) return null;

  return <ExploreMapLayer floorId={floorId} />;
};

// Builds the tab's layer for the page's one map, which the map stage draws
const ExploreMapLayer = ({ floorId }: { floorId: string }) => {
  const { building } = useRequiredContext(HaNContext);
  const resources = useAppSelector(state => {
    return getBuildingResources(state, building.buildingId ?? "")?.resources ?? NO_RESOURCES;
  });

  // Until explore has its search and filters, every resource is a result
  const layer = buildExploreMapLayer({ floorId, resources, results: resources, activeTypeFilters: NO_TYPE_FILTERS });

  useHaNMapLayer(layer);

  return null;
};
